import React from "react";
import * as _ from "lodash";
import "../../css/page.css";
import { Footer, FooterLinks, FooterIcon } from "./styled_app_footer";
import getLocale from "../../helpers/getLocale";
import translations from "../../locales";
import headerLogo from "../../assets/img/header_logo.svg";

export class AppFooter extends React.Component {
  render() {
    const locale = getLocale();
    const linkData = _.get(
      translations[locale],
      "it_rsvp_30th_anniv.footer.link_data"
    );

    return (
      <Footer>
        <FooterIcon>
          <img src={headerLogo} alt="header" />
        </FooterIcon>
        <FooterLinks>
          <a
            href={linkData.phone.url}
            className="element footer-element-phone"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span lang={locale}><span dangerouslySetInnerHTML={{ __html: linkData.phone.label}} /></span>
          </a>
          <a
            href={linkData.email.url}
            className="element"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span lang={locale}>{linkData.email.label}</span>
          </a>
          <a
            onClick={() => window.open(linkData.privacy.url)}
            className="element"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span lang={locale}>{linkData.privacy.label}</span>
          </a>
          <a
            onClick={() => window.open(linkData.legal.url)}
            className="element"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span lang={locale}>{linkData.legal.label}</span>
          </a>
        </FooterLinks>
      </Footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/app_footer/app_footer.js